export const PlatformEvents = {
  // Home page
  HOMEPAGE_VIEWED: "homepage/viewed",
  HOMEPAGE_AI_SEARCH_SUBMITTED: "homepage/ai-search-submitted",
  HOMEPAGE_PRODUCT_CARD_CLICKED: "homepage/product-card-clicked",
  HOMEPAGE_ADVERTISING_CARD_CLICKED: "homepage/advertising-card-clicked",

  // Top nav
  NAV_TEAM_SWITCHER_OPENED: "nav/team-switcher-opened",
  NAV_TEAM_SWITCHED: "nav/team-switched",
  NAV_SEARCH_OPENED: "nav/search-opened",
  NAV_SEARCH_SUBMITTED: "nav/search-submitted",
  NAV_ASK_REDO_CLICKED: "nav/ask-redo-clicked",
  NAV_USER_MENU_OPENED: "nav/user-menu-opened",
  NAV_LOGOUT_CLICKED: "nav/logout-clicked",

  // Left sidebar
  NAV_SIDEBAR_ITEM_CLICKED: "nav/sidebar-item-clicked",
  NAV_SETTINGS_ITEM_CLICKED: "nav/settings-item-clicked",
  NAV_TAB_REORDERED: "nav/tab-reordered",

  // Onboarding & upsell
  UPSELL_CARD_CTA_CLICKED: "upsell/card-cta-clicked",
  UPSELL_PAGE_VIEWED: "upsell/page-viewed",
  UPSELL_CTA_CLICKED: "upsell/cta-clicked",

  // Intent ad landing
  INTENT_MARKER_WRITTEN: "intent/marker-written",
} as const;
